export default __webpack_public_path__ + "static/og-bf7cdffd8470c0c3d37b7efc32c61776.jpg";